import { PHASE_LABELS, type PhaseStatus } from "../types/api";
import { formatDurationMs } from "../utils/format";

interface PipelineRailProps {
  phaseStatus: PhaseStatus[];
  phaseElapsedMs: (number | null)[];
}

export function PipelineRail({ phaseStatus, phaseElapsedMs }: PipelineRailProps) {
  return (
    <div className="pipeline-rail" role="list" aria-label="Pipeline phases">
      {PHASE_LABELS.map((label, i) => {
        const status = phaseStatus[i];
        const elapsed = phaseElapsedMs[i];
        const statusLine =
          status === "active"
            ? "running"
            : status === "done" && elapsed != null
              ? formatDurationMs(elapsed)
              : status === "error"
                ? "failed"
                : "";

        return (
          <div
            key={label}
            className={`rail-segment rail-${status}`}
            role="listitem"
            aria-current={status === "active" ? "step" : undefined}
          >
            <span className="rail-idx">{String(i + 1).padStart(2, "0")}</span>
            <span className="rail-name">{label}</span>
            <span className="rail-status">{statusLine}</span>
            <div className="rail-bar">
              <i className={status === "active" ? "indeterminate" : ""} />
            </div>
          </div>
        );
      })}
    </div>
  );
}
